import { formatToDollar, formatToPercent } from "@inrev/common";
import { Option } from "@inrev/core";
import type { AdminSuretyBond } from "@portal/api/bond/admin";
import type { SuretyBond } from "@portal/api/bond/agent";
import { DateTime } from "luxon";

export const formatBondMediumDate = (iso: string) =>
	DateTime.fromISO(iso).toLocaleString(DateTime.DATE_MED);

type BondWithHeaderTerms = AdminSuretyBond | SuretyBond;

const originalEffectiveDate = (bond: BondWithHeaderTerms) => {
	const earliest = (bond.bondPeriods ?? []).reduce<Option<string>>((earliestDate, period) => {
		if (Option.isNone(earliestDate) || period.effectiveDate < earliestDate)
			return period.effectiveDate;
		return earliestDate;
	}, undefined);
	return Option.getOrElse(earliest, bond.effectiveDate);
};

export const bondHeaderTermMetrics = (bond: BondWithHeaderTerms) =>
	bond.contractSuretyType === "bid"
		? [
				{ label: "Final Bond Rate", value: formatToPercent(bond.finalBondContingentRate, 3) },
				{
					label: "Final Bond Premium",
					value: formatToDollar(bond.finalBondContingentPremium) ?? "--",
				},
				{ label: "Commission", value: formatToPercent(bond.finalBondAgencyCommissionPercentage) },
			]
		: [
				{ label: "Rate", value: formatToPercent(bond.rate, 3) },
				{ label: "Premium", value: formatToDollar(bond.premium) ?? "--" },
				{ label: "Commission", value: formatToPercent(bond.agencyCommissionPercentage) },
				{
					label: "Original Effective Date",
					value: formatBondMediumDate(originalEffectiveDate(bond)),
				},
				...(Option.isSome(bond.expirationDate)
					? [{ label: "Expiration", value: formatBondMediumDate(bond.expirationDate) }]
					: []),
			];
